import React from 'react';
import { FiEdit2, FiFileText } from 'react-icons/fi';
import { Link } from 'react-router-dom';
import Excluir from '../excluir/Excluir';

export function EditBtn({ to }) {
  return (
    <Link to={to} title="Editar" style={{ textDecoration: 'none' }}>
      <button
        style={{
          width: 30, height: 30, border: 'none', borderRadius: 6, cursor: 'pointer',
          color: '#3b82f6', background: 'rgba(59,130,246,0.08)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          transition: 'background 0.15s',
        }}
        onMouseEnter={e => e.currentTarget.style.background = 'rgba(59,130,246,0.18)'}
        onMouseLeave={e => e.currentTarget.style.background = 'rgba(59,130,246,0.08)'}
      >
        <FiEdit2 size={14} />
      </button>
    </Link>
  );
}

export function DeleteBtn({ url, id, redirect, component, texto }) {
  return (
    <div
      style={{
        width: 30, height: 30, border: 'none', borderRadius: 6, cursor: 'pointer',
        color: '#ef4444', background: 'rgba(239,68,68,0.08)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        transition: 'background 0.15s',
      }}
      onMouseEnter={e => e.currentTarget.style.background = 'rgba(239,68,68,0.18)'}
      onMouseLeave={e => e.currentTarget.style.background = 'rgba(239,68,68,0.08)'}
    >
      <Excluir url={url} id={id} redirect={redirect} component={component} texto={texto} />
    </div>
  );
}

export function InadimplenciasBtn({ onClick }) {
  return (
    <button
      type="button"
      title="Ver inadimplências"
      aria-label="Ver inadimplências"
      onClick={onClick}
      style={{
        width: 30, height: 30, border: 'none', borderRadius: 6, cursor: 'pointer',
        color: '#d97706', background: 'rgba(217,119,6,0.08)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        transition: 'background 0.15s',
      }}
      onMouseEnter={e => e.currentTarget.style.background = 'rgba(217,119,6,0.18)'}
      onMouseLeave={e => e.currentTarget.style.background = 'rgba(217,119,6,0.08)'}
    >
      <FiFileText size={14} />
    </button>
  );
}

export function Actions({ children }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'row', gap: 6, justifyContent: 'center' }}>
      {children}
    </div>
  );
}
